/*
 * Copyright (c) 2026. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
* Projectedit.ts
* 12-5-2020 - Jelmer Jellema - Spin in het Web B.V.
*/

import {Component, OnInit} from '@angular/core';
import {Project} from '../../models/project';
import {Editmodelscherm} from '../abstracts/editmodelscherm';
import {Functie} from '../../models/functie';
import {ProjectFunctie} from '../../models/project_functie';
import { Gebruiker } from 'src/models/gebruiker';
import {Werkmaatschappij} from '../../models/werkmaatschappij';

@Component({
  selector: 'project-edit',
  templateUrl: './projectedit.html',
  styleUrls: ['./projectedit.scss']
  //zie styling van datatable in globals
})
export class Projectedit extends Editmodelscherm<typeof Project> implements OnInit {
  _starttitle = 'Project';
  icon = 'fas fa-hard-hat'; //bij sjabloon overschreven in init
  model = Project; //nodig voor concrete instantiering

  protected defaultRecord = {
    kleur: '#000000'
  };

  defaultSubmodels = [ProjectFunctie]; //alles, zelfs de invulling
  lookupQueries = {
    gebruikersnaam: {
      model: Gebruiker,
      order: ['naam'],
      aclModel: Project
    },
    functie: {
      model: Functie,
      table: 'functie',
      order: ['naam'],
      aclModel: Project
    },
    werkmaatschappij: {
      model: Werkmaatschappij,
      aclModel: Project,
      order: ['naam']
    }
  };

  //constructor ivm injection
  constructor() {
    super('debug');

  }

  /**
   * Specific init code needed?
   */
  override async ngOnInit() {
    await super.ngOnInit();
  }

  /**
   * Parse data after getting it?
   * @protected
   */
   protected async afterHaaldata() {
    await super.afterHaaldata();
  }


  ///////////////////////// titel etc //////////////////

  /**
   * Dynamische titel
   */
  get title(): string {
    return this.isNieuw ? `Nieuw project` : `${this.record.orig('naam')} - Bewerk project`;
  }

  //recordbeschrijving
  get recordBeschrijving(): string {
    return this.isNieuw ? `een nieuw project` : `project '${this.record.orig('naam')}'`;
  }

  ////////////////// UX /////////////////////
  /**
   * Lookup-wrapper
   * @param functie_id
   */
  functienaam(functie_id: number): string
  {
   if (this.lookupHashes?.functie)
   {
     let functie: Functie = <Functie> this.lookupHashes.functie[functie_id];
     if (functie)
     {
       return functie.naam;
     }
   }
   return '?';
  }

  //// gebruikers in de juiste wm
  public get wmGebruikers(): Gebruiker[] {
    if (! (this.lookups?.gebruikersnaam && this.record.werkmaatschappij_id))
    {
      return [];
    }
    return (<Gebruiker[]>this.lookups.gebruikersnaam).filter(g => g.gebruiker_werkmaatschappij.some(gwm =>gwm.werkmaatschappij_id === this.record.werkmaatschappij_id))
  }

  /**
   * Lijst met externe werkmaatschappijen, gefilterd zodat de eigen werkmaatschappij nooit gekozen kan worden
   */
  public get externeWerkmaatschappijen(): Werkmaatschappij[] {
    return (this.lookups?.werkmaatschappij as Werkmaatschappij[])?.filter(wm => wm.id !== this.record.werkmaatschappij_id) || [];
  }
}
